import React, { useState, useMemo } from 'react'
import { courierGuyLockers, provinces } from './constants'

const LockerModal = ({ onSelect, onClose }) => {
  const [search, setSearch] = useState('')
  const [provinceFilter, setProvinceFilter] = useState('')

  const filteredLockers = useMemo(() => {
    let list = courierGuyLockers
    if (provinceFilter) {
      list = list.filter((l) => l.province === provinceFilter)
    }
    if (search.trim()) {
      const q = search.toLowerCase()
      list = list.filter(
        (l) =>
          l.name.toLowerCase().includes(q) ||
          l.address.toLowerCase().includes(q) ||
          l.city.toLowerCase().includes(q),
      )
    }
    return list
  }, [search, provinceFilter])

  const handleSelect = (locker) => {
    onSelect(locker)
    onClose()
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="flex max-h-[80vh] w-full max-w-lg flex-col rounded-xl bg-white shadow-xl">
        <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
          <h3 className="text-lg font-bold text-gray-900">Select a Courier Guy Locker</h3>
          <button
            type="button"
            onClick={onClose}
            className="rounded-full p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
        </div>

        <div className="border-b border-gray-200 px-6 py-3">
          <div className="flex gap-2">
            <div className="relative flex-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <input
                type="text"
                placeholder="Search lockers..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full rounded-lg border border-gray-300 py-2 pl-10 pr-4 text-sm outline-none focus:border-violet-500 focus:ring-1 focus:ring-violet-500"
              />
            </div>
            <select
              value={provinceFilter}
              onChange={(e) => setProvinceFilter(e.target.value)}
              className="rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none focus:border-violet-500 focus:ring-1 focus:ring-violet-500"
            >
              <option value="">All Provinces</option>
              {provinces.map((p) => (
                <option key={p} value={p}>{p}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-3">
          {filteredLockers.length === 0 ? (
            <p className="py-8 text-center text-sm text-gray-400">No lockers found.</p>
          ) : (
            <div className="space-y-2">
              {filteredLockers.map((locker) => (
                <button
                  key={locker.id}
                  type="button"
                  onClick={() => handleSelect(locker)}
                  className="w-full rounded-lg border border-gray-200 p-3 text-left text-sm transition hover:border-gray-300 hover:bg-gray-50"
                >
                  <p className="font-semibold text-gray-900">{locker.name}</p>
                  <p className="mt-0.5 text-xs text-gray-500">{locker.address}, {locker.city}</p>
                  <p className="mt-0.5 text-xs text-gray-400">{locker.province}</p>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default LockerModal
